import { UpperCasePipe } from '@angular/common';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslocoModule } from '@jsverse/transloco';
import { CodeInputModule } from 'angular-code-input';
import { IgnorePasswordManagersDirective } from '../../../../shared/directives';

/** Matches [codeLength] in the template. */
const CODE_LENGTH = 6;

@Component({
    selector: 'app-security-code',
    templateUrl: './security-code.component.html',
    styleUrls: ['./security-code.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TranslocoModule,
        CodeInputModule,
        FlexLayoutModule,
        MatButtonModule,
        MatDialogModule,
        UpperCasePipe,
        IgnorePasswordManagersDirective
    ]
})
export class SecurityCodeComponent {
    complete = false;
    code: number | undefined;

    private readonly _dialogRef = inject(MatDialogRef<SecurityCodeComponent>);

    /**
     * Keeps `complete` honest while the code is being edited. Without this, deleting a digit
     * after filling all six left `complete` true and `code` holding the previous value, so
     * Submit stayed enabled and would send a stale code.
     */
    onCodeChanged(code: string) {
        if (code?.length === CODE_LENGTH) return;

        this.complete = false;
        this.code = undefined;
    }

    onCodeCompleted(code: string) {
        this.complete = true;
        this.code = Number(code);
    }

    cancel() {
        this.complete = false;
        this.code = undefined;
        this._dialogRef.close();
    }
}
